import React from 'react';
import './BookingStepper.css';

interface Props {
  currentStep: 1 | 2 | 3 | 4;
}

export const BookingStepper: React.FC<Props> = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'الرحلة' },
    { number: 2, label: 'المقعد' },
    { number: 3, label: 'الدفع' },
    { number: 4, label: 'التأكيد' },
  ];

  return (
    <div className="mobile-stepper-bar" dir="rtl" aria-label="مراحل الحجز">
      <div className="stepper-track">
        {steps.map((s, index) => {
          const isCompleted = s.number < currentStep;
          const isActive = s.number === currentStep;

          return (
            <React.Fragment key={s.number}>
              <div
                className={`stepper-node ${isActive ? 'active' : ''} ${
                  isCompleted ? 'completed' : ''
                }`}
              >
                <div className="node-circle">
                  {isCompleted ? '✓' : s.number}
                </div>
                <span className="node-text">{s.label}</span>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`stepper-connector ${
                    s.number < currentStep ? 'completed' : ''
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
